<template>
  <div class="editor-wrapper editor-text-style">
    <ckeditor
      v-model="value"
      @blur="$emit('blur')"
      :editor="editor"
      :disabled="disabled"
      :config="editorConfig"/>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
// TODO: PlugIns
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline'
import Link from '@ckeditor/ckeditor5-link/src/link'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Indent from '@ckeditor/ckeditor5-indent/src/indent'
import List from '@ckeditor/ckeditor5-list/src/list'
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

export default {
  name: 'editor',
  props: {
    model: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      value: this.model || '',
      editor: ClassicEditor,
      editorConfig: {
        plugins: [Essentials, Bold, Italic, Underline, Alignment, Link, Indent, List, Paragraph, Table, TableToolbar],
        toolbar: {
          items: [
            'bold', 'italic', 'underline', 'link', '|',
            'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify', '|',
            'bulletedList', 'numberedList', '|',
            'outdent', 'indent', 'insertTable'
          ],
          shouldNotGroupWhenFull: true
        }
      },
      debounceHandleChange: this.$_.debounce(this.update, 300),
      elFormItem: null
    }
  },
  watch: {
    model (value) {
      if (value !== this.value) this.value = value || ''
    },
    'value': 'debounceHandleChange'
  },
  mounted () {
    this.findElFormItem()
    if (this.elFormItem) this.elFormItem.$el.setAttribute('data-filed', 'true')
  },
  methods: {
    update () {
      this.$emit('update:model', this.value)
    },
    findElFormItem () {
      const findFunc = (Component) => {
        if (!this.elFormItem) {
          if (Component.$options.name === 'ElFormItem') {
            this.elFormItem = Component
          } else if (Component.$options.name === 'root') {
            return false
          } else if (Component.$parent) {
            findFunc(Component.$parent)
          }
        }
      }
      findFunc(this.$parent)
    }
  }
}
</script>

<style lang="stylus">
  .editor-wrapper {
    margin 1rem 0 0
  }
</style>
